export enum LogLevel {
	DEBUG = 'DEBUG',
	ERROR = 'ERROR',
	FATAL = 'FATAL',
	INFO = 'INFO',
	TRACE = 'TRACE',
	WARNING = 'WARN'
}

const LOG_LEVEL_SEQUENCE: LogLevel[] = [
	LogLevel.TRACE,
	LogLevel.DEBUG,
	LogLevel.INFO,
	LogLevel.WARNING,
	LogLevel.ERROR,
	LogLevel.FATAL
];

export function meetsLoggingThreshold(level: LogLevel, threshold: LogLevel): boolean {
	return threshold &&
		LOG_LEVEL_SEQUENCE.indexOf(level) >= LOG_LEVEL_SEQUENCE.indexOf(threshold);
}
